// extracted by mini-css-extract-plugin
module.exports = {"desktopView":"_9f8d4b2","phoneView":"_4c817e8","gameTitle":"_ec889dc","gameInfo":"_64be46f","gameTitleHide":"_12002cf","gameButton":"_3ef311c","gameInfoSh":"_41ea887"};